var Handlebars = require("/Users/mauricengo/styleguide-test/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\n"
    + ((stack1 = container.invokePartial(require("/Users/mauricengo/styleguide-test/src/materials/elements/buttons/full-.html"),depth0,{"name":"buttons.full-","hash":{"text":"Notify Me When Available","href":"./notify-me.html"},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/materials/modules/cta-buttons/notify-me.html
// module id = 79
// module chunks = 0